import React from 'react';
import { useAppDispatch } from '../../app/hooks';
import NumberInput from '../common/NumberInput';
import { show as showSkillInfo } from './skillInfoSlice';
import { getTrainerResults, setSkillTargetPercent } from './skillTrainerSlice';

function SkillItem({
    id,
    name,
    percentStart,
    percentTarget,
    percentActual,
    pracsActual,
    useLevel,
    busy
  }: Props) {
  const dispatch = useAppDispatch();
  
  let newValue = percentTarget;
  let max = 99;
  let hint = '%';

  if (useLevel) {
    newValue = Math.floor(percentTarget / 14);
    max = 7;
    hint = 'LVL';
  }

  const handleTargetChange = (value: number) => {
    const percent = useLevel ? value * 14 : value;
    dispatch(setSkillTargetPercent({ skillId: id, percent }));
    dispatch(getTrainerResults());
  };

  const handleSkillClick = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(showSkillInfo(id));
  }

  return (
    <div className="skill-item">
      <div className="weave-name-col d-flex align-items-center">
        <a tabIndex={-1} href="/#" className="weave-name" onClick={e => handleSkillClick(e)}>{name}</a>
        {percentStart ? <div className="start-percent">*</div> : null}
      </div>
      <NumberInput
        className="weave-target" size="sm" min={0} max={max} numberValue={newValue || null}
        placeholder={hint}
        onNumberChange={e => handleTargetChange(e ?? 0)} />
      <div className="weave-results-col">
        {busy ?
          <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        : null}

        {!busy && !percentActual ?
          <></>
        : null}

        {!busy && percentActual ?
          <>
            <div className={`weave-percentage`}>{percentActual ? `${percentActual}%` : ''}</div>
            <div className={`weave-practices`}>{percentActual ? `${pracsActual} prac`: ''}</div>
          </>
        : null}
      </div>
    </div>
  );
}

type Props = {
  id: string;
  name: string;
  percentStart: number;
  percentTarget: number;
  percentActual: number;
  pracsActual: number;
  useLevel: boolean;
  busy: boolean;
};

export default React.memo(SkillItem);